import React, { Component } from 'react';
import { Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import { COLORS } from '../../../utils/Application_Constants';
import AssignmentListItem from '../AssignmentListItem/AssignmentListItem';
import AssignmentListEmptyState from '../AssignmentListItem/AssignmentListEmptyState';

const styles = (theme) => ({
    header: {
        color: COLORS.WATERLOO,
        fontWeight: '700',
        fontSize: '18px',
        width: '90%',
        padding: '18px 0 0 20px',
        textAlign: 'left',
    },
    assignmentListPaperWrapper: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
    },
});

class UpcomingAssignmentList extends Component {
    renderAssignments = () => {
        const { assignments, toggleAssignmentView } = this.props;
        if (!assignments || assignments.length === 0) {
            return (
                <div style={{ width: '100%' }}>
                    <AssignmentListEmptyState assignmentType="upcoming" />
                </div>
            );
        }
        return (
            <Grid container>
                {assignments.map((item) => (
                    <AssignmentListItem
                        type="upcoming"
                        key={item.name}
                        assignment={item}
                        toggleAssignmentView={toggleAssignmentView}
                    />
                ))}
            </Grid>
        );
    };

    renderAssignmentTitleConditonally = () => {
        const { assignments } = this.props;
        if (!assignments || assignments.length === 0) {
            return <span className="tileHeader">Upcoming Assignments</span>;
        }
        return (
            <span className="tileHeader">
                Upcoming Assignments(
                {assignments.length})
            </span>
        );
    };

    render() {
        return (
            <div>
                {/* {this.renderAssignmentTitleConditonally()} */}
                <Grid container>{this.renderAssignments()}</Grid>
            </div>
        );
    }
}

export default withStyles(styles)(UpcomingAssignmentList);
